module.exports = __webpack_public_path__ + "static/law-enforcement-e351373afdbecc702d3b7c5fa56597d4.jpg";